import {Boards} from './Boards.js';
import {BoardPost} from './BoardPost.js';
import {Message} from './Message.js';
import {Template} from './Template.js';

export class Board extends HTMLElement {
	constructor() {
		super();
		this.inited = false;
	}
	init() {
		this.inited = true;
		[this.el, this.$] = Template(`Board`);
		this.appendChild(this.el);
		this.boardId = parseInt(this.getAttribute(`board-id`));

		this.$.title.innerText = this.getAttribute(`title`);
		// this.$.id.innerText = this.getAttribute(`board-id`);
		this.$.add_message.setAttribute(`aria-label`,`Post a message to the ${this.getAttribute('title')} board.`);
		this.$.add_message.addEventListener(`click`, evt=>{
			evt.stopPropagation();
			BoardPost.post(this.getAttribute(`board-id`)).then( res=> {
				if (res) {
					const m = new Message(this.el, this.$.messages, res[0]);
					m.scrollIntoView();
				}
			});
		});
		Boards.API().Messages(this.boardId).then( messages=> {
			console.log(`Boards.API.Messages = `, messages);
			messages.forEach( m=>{
				new Message(this.el, this.$.messages, m);
			})
		});
	}
	connectedCallback() {
		if (!this.inited) this.init();
	}
}
customElements.define(`board-board`, Board);